/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useEffect } from 'react';

// redux
import {useDispatch, useSelector} from "react-redux";
import {fetchAccountSettings, fetchInitialRevenueDate} from "../../../../state/thunks/account";
// utils

// material
import { Page, Content } from '@insticator/insticator-ui';
import PageHeader from '../../../../material/structure/pageheader/pageheader';
import PageContent from '../../../../material/structure/pagecontent/pagecontent';
import Disabledglobalfilter from "../../reportbuilder/monetizationform/filter/disabledglobalfilter/disabledglobalfilter";

// styles
import injectSheet from 'react-jss';
import styles from './configuration_styles';

// components
import AdvancedConfig from "./advanced/advanced";
import HistoricalData from "./historical/historical";
import Header from "../../../../material/structure/header/header";



/* ========== ~~~~~~~~~~ MONETIZATION - ENGAGEMENT PRODUCTS PAGE ~~~~~~~~~~ ========== */
const ConfigurationPage = injectSheet(styles)((props) => {
  const dispatch = useDispatch();
  const {
    session: {
      accountUUID,
      mocked
    }
  } = useSelector((state) => state)


  useEffect(() => {
    dispatch(fetchAccountSettings(accountUUID))
  }, [])

    return (
        <Page name={'configuration'}  className={props.classes.configuration}>
            <Header>
                <Disabledglobalfilter />
            </Header>
            <Content>
                <PageHeader title={'Monetization'} subtitle={'Configuration'} />
                <PageContent>
                    {mocked && <AdvancedConfig />}
                    <HistoricalData />
                </PageContent>
            </Content>
        </Page>
    );
});


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default ConfigurationPage;
